import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=d8328b6e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=d8328b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8328b6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8328b6e')) {
      api.createRecord('d8328b6e', component.options)
    } else {
      api.reload('d8328b6e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=d8328b6e&scoped=true&", function () {
      api.rerender('d8328b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4JxB9d7E10Hv5/JS/comp/DocBox.vue"
export default component.exports